export function parseMoldReleaseDeepLink(search) {
  const params = new URLSearchParams(search || '');
  const toolId = (params.get('toolId') || '').trim();
  const moldInfoIdRaw = params.get('moldInfoId');
  const moldInfoId = moldInfoIdRaw ? Number(moldInfoIdRaw) : null;

  if (!toolId && !(Number.isFinite(moldInfoId) && moldInfoId > 0)) {
    return null;
  }

  return {
    toolId,
    moldInfoId: Number.isFinite(moldInfoId) && moldInfoId > 0 ? moldInfoId : null,
  };
}
